import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import {GetServerSideProps} from "next";
import Image from "next/image";
import ContactUsPanel from "../../components/ContactUsPanel/ContactUsPanel";
import HeaderImageWithHeading from "../../components/common/HeaderImageWithHeading";
import Button from "../../components/common/Button";
import {getSafeLocale} from "../../helpers/LocalizeObject";

interface WeitereLeistungenInterface {
	heading: string;
	desc: string;
	bullets: string[];
	img: string;
	moreText: string;
}

export default function Page() {
	const {t} = useTranslation();

	const services = t("pages.weitereLeistungen.services", {
		returnObjects: true
	}) as WeitereLeistungenInterface[];

	return (
		<>
			<HeaderImageWithHeading
				title={t("pages.weitereLeistungen.heading")!}
				subtitle={t("pages.weitereLeistungen.subHeading")!}
			/>
			<div className="container mx-auto my-20 flex flex-col gap-y-10 lg:gap-y-40 ">
				{services.map((p, idx) => (
					<div
						className="flex flex-col xl:odd:flex-row md:even:flex-row-reverse gap-x-10 w-full"
						key={"leistung-" + idx}
					>
						<div className="flex-1 relative w-full aspect-square shrink-0">
							<Image
								quality={90}
								alt={p.heading}
								src={p.img}
								fill
								className="object-scale-down"
							/>
						</div>
						<div className="flex-1 items-center p-6">
							<h3>{p.heading}</h3>
							<br/>
							<p>{p.desc}</p>
							<br/>
							<ul className="pl-10">
								{p.bullets.map((b, idx) => (
									<li key={idx} className="list-disc">
										{b}
									</li>
								))}
							</ul>
							<br/>
							<p>{p.moreText}</p>
							<br/>
							<div className="max-w-[200px]">
								<Button
									text={"Jetzt anfragen"}
									transparent={false}
									border={false}
									href={"/kontakt"}
									className="mt-5 rounded-[10px]"
									padding={"px-6 py-[14px]"}
								/>
							</div>
						</div>
					</div>
				))}
			</div>
			<ContactUsPanel/>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	const sst = await serverSideTranslations(getSafeLocale(context.locale) as string, [
		"common"
	]);
	return {
		props: {
			...sst
		}
	};
};
